import React, { useState, useEffect } from "react";
import { Box, Flex, Text, NumberFormatter } from "@mantine/core";
import axios from "axios";
import styled from "styled-components";
import { shallow } from "zustand/shallow";
import { Speedometer } from "@components/DataViz";
import { Odometer } from "@components/RideChallenge";
import { LocationItem, ReadingItem } from "./DashboardHistory";

import useAppStore from "@components/Microsite/microsite-store";

export default function VehicleDataOdometer() {
  const { dashboardData, setAppLoading } = useAppStore(
    (state) => ({
      dashboardData: state.dashboardData,
      setAppLoading: state.setAppLoading,
    }),
    shallow
  );

  if (!dashboardData) return null;

  const lastReading = dashboardData.latest_validated_reading;
  if (!lastReading) return <div style={{ paddingBottom: "40px" }}></div>;

  return (
    <div style={{ width: "100%" }}>
      {/* <GaugeGoalWrapper>
        <Speedometer value={4000} maxValue={10000} fillProgress />
      </GaugeGoalWrapper> */}
      {/* <OdometerWrapper>
        <Odometer newValue={lastReading.odometer_value} isVehicleDataEffort />
      </OdometerWrapper> */}
      <Box maw="90% " mx="auto" pb="lg" mt="xl">
        <ReadingItem
          reading={{
            user_vehicle: {
              year: lastReading.year,
              make: lastReading.make,
              model: lastReading.model,
              series: lastReading.series,
              assets: [{ filename_url: lastReading.location_logo_url }],
            },
            odometer_value: lastReading.odometer_value,
            location_name: lastReading.location_name,
            verified_at: lastReading.verified_at,
            alt_text: "Latest reading",
          }}
        />
      </Box>
    </div>
  );
}

const OdometerWrapper = styled.div`
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  position: relative;
  /* top: -50px; */
  padding: 20px 0 10px 0;

  .odometer-value {
    /* font-size: 40px; */
  }
`;

const GaugeGoalWrapper = styled.div`
  position: relative;
  p {
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    text-transform: uppercase;
    text-align: center;
    position: relative;
    margin-top: 0;
    margin-bottom: 0;
  }
`;
